const mapOnHoldDetailFromApi = ({
  reference,
  referenceId,
  orderCount,
  orderIds
}) => ({
  id: referenceId,
  reference: reference,
  totalOrdersAffected: orderCount,
  ordersAffected: orderIds
})

const mapOnHoldReasonFromApi = ({
  reasonId,
  reason,
  orderCount,
  data
}) => ({
  id: reasonId,
  name: reason,
  totalOrdersAffected: orderCount,
  details: data.map(mapOnHoldDetailFromApi)
})

export const mapOnHoldNotificationsFromApi = (notifications) => ({
  notifications: notifications.map(mapOnHoldReasonFromApi)
})
